export default "/assets/images/mila-air-au-sm.30ddf5b258c4eeb9.png";